// extracted by mini-css-extract-plugin
export default {"logo":"LeverCard_logo__BbwI1"};